import React from "react";
import { GenericForm } from "./GenericForm";

export function ZoneManager() {
  return <GenericForm type="zoneManager" />;
}
